/* eslint-disable lingui/no-unlocalized-strings */

import { join } from '../array/join';
import env from '../env';
import { captureException, captureMessage } from './utils';
export function sentryFetchHandler(result) {
  if (env.REACT_APP_SENTRY_ENABLED === 'true') {
    const message = `Request error`;
    const messageDetails = result?.error?.message || result?.error?.errors?.[0]?.message;
    captureMessage(join([message, messageDetails], ': '), {
      level: 'error',
      contexts: {
        RequestError: {
          ...result?.error,
          httpStatus: result?.status,
          method: result?.request?.method,
          corrId: result?.request?.headers?.get('X-CF-CORR-ID')
        }
      }
    });
  }
}
export function sentryFetchExceptionHandler(result) {
  if (env.REACT_APP_SENTRY_ENABLED === 'true') {
    captureException(result.exception, {
      contexts: {
        RequestError: {
          url: result.request.url,
          method: result.request.method,
          corrId: result.request.headers?.get('X-CF-CORR-ID')
        }
      }
    });
  }
}
//# sourceMappingURL=sentryFetchHandler.js.map